import { render, staticRenderFns } from "./tags-nav.vue?vue&type=template&id=0bcdad9e&"
import script from "./tags-nav.vue?vue&type=script&lang=js&"
export * from "./tags-nav.vue?vue&type=script&lang=js&"
import style0 from "./tags-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports